import React from "react";

/**
 * The section renderer shared by the full `/terms` · `/privacy` pages
 * (LegalPage.jsx) and the in-flow signup modal (LegalModal.jsx). Pulled out on
 * purpose: the two surfaces show the exact same legal text, and a divergence
 * between them — a section present on the page but missing from the modal —
 * would mean two different documents are in force depending on how someone
 * got there.
 *
 * `break-words` because the documents cite addresses (Meta's controller
 * addendum URL) that are wider than a 360px phone and have no space to wrap at.
 */

/** Renders `**bold**` runs. Legal text needs emphasis on defined terms and little else. */
const RichText = ({ text }) => (
  <>
    {text.split("**").map((part, index) =>
      index % 2 === 1 ? (
        <strong key={index} className="font-semibold text-ink-900">
          {part}
        </strong>
      ) : (
        part
      ),
    )}
  </>
);

const Body = ({ items }) => (
  <>
    {items.map((item, index) =>
      typeof item === "string" ? (
        <p key={index} className="mt-3 break-words text-fluid-sm leading-relaxed text-ink-600">
          <RichText text={item} />
        </p>
      ) : (
        <ul key={index} className="mt-3 space-y-2 pl-5">
          {item.list.map((entry, entryIndex) => (
            <li
              key={entryIndex}
              className="list-disc break-words text-fluid-sm leading-relaxed text-ink-600"
            >
              <RichText text={entry} />
            </li>
          ))}
        </ul>
      ),
    )}
  </>
);

const LegalDocumentBody = ({ sections }) => (
  <>
    {sections.map((section) => (
      <section key={section.heading} className="legal-section mt-9">
        <h2 className="text-base font-semibold text-ink-900">{section.heading}</h2>
        <Body items={section.body} />
      </section>
    ))}
  </>
);

export default LegalDocumentBody;
